import PaginationComponent from "slotworks/components/ui/pagination-component";
import SlotDefinition from "slotworks/model/slot-definition";
import { Services } from "slotworks/services/services";
import ControlOptions from "slotworks/smart-ui/options/control-options";

export enum PayoutMode {
    LINES = "lines",
    WAYS = "ways",
    FIXED = "fixed",
    MULTIPLIER_ONLY = "multiplierOnly"
}

export default class PaytableComponent extends PaginationComponent {

    // TODO: Review whether these should be handled in control
    public static payoutMode: PayoutMode = PayoutMode.LINES;
    // The minimum bet in a ways game (if applicable)
    public static waysBaseBet: number;

    private cachedOptions: ControlOptions;

    public updateOptions(options: ControlOptions) {
        this.cachedOptions = options;

        this.updatePayouts();
    }

    protected update() {
        super.update();

        this.updatePayouts();
    }

    private updatePayouts() {
        if (this.cachedOptions) {

            const symbols = SlotDefinition.symbolDefinitions;

            for (const symbol of symbols) {
                const payoutsText = this.contentLayer.getFlexiText("payouts_" + symbol.id);

                if (payoutsText) {
                    let payouts = "";
                    if (symbol.payouts) {
                        let output;
                        symbol.payouts.forEach((payout) => {
                            output = this.getPayoutValue(payout);

                            if (payouts) {
                                payouts = output + "\n" + payouts;
                            } else {
                                payouts = output;
                            }
                        });
                    }

                    payoutsText.setText(payouts);
                }

                if (symbol.payouts) {
                    symbol.payouts.forEach((payout, matches) => {
                        const payoutText = this.contentLayer.getFlexiText("payouts_" + symbol.id + "_" + matches);

                        if (payoutText) {
                            payoutText.setText(this.getPayoutValue(payout));
                        }
                    });
                }
            }
        }
    }

    private getPayoutValue(payout: number): string {
        let toReturn;
        let amount;

        const stakePerLine = this.cachedOptions.creditsPerLine.currentValue * this.cachedOptions.creditSizes.currentValue;

        if (PaytableComponent.payoutMode === PayoutMode.FIXED) {
            const betPerLine = (this.cachedOptions.fixedBetCost / this.cachedOptions.selectedLines);
            amount = payout * stakePerLine * betPerLine;
            toReturn = Services.currency.format(amount, false);
        } else if (PaytableComponent.payoutMode === PayoutMode.LINES) {
            amount = payout * stakePerLine;
            toReturn = Services.currency.format(amount, false);
        } else if (PaytableComponent.payoutMode === PayoutMode.WAYS) {
            amount = payout * this.cachedOptions.getTotalStake() / PaytableComponent.waysBaseBet;
            toReturn = Services.currency.format(amount, false);
        } else {
            toReturn = payout;
        }

        return toReturn.toString();
    }
}
